import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import '../../../assets/styles/KYC.css'
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useDistributorContext } from '../../../services/contexts/DistributorContext';
// import { useCustomerKYCContext } from '../../../services/contexts/CustomerKYCContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import DistributorReviewRequestDetailPage from './DistributorReviewRequestDetailPage';
import DistributorReviewRequestsPage from './DistributorReviewRequestsPage';


export default function DistributorMainPage() {

    const { kycRequesterUserDetail, setKycRequesterUserDetail } = useDistributorContext()
    const { setCurrModule, allowedFunc } = useLogin()

    const history = useHistory()

    let { customerId } = useParams();

    useEffect(() => {
        if (allowedFunc.includes(configs.functionList['kyc:read_distributor_kyc_info'] || allowedFunc.includes(configs.functionList['kyc:update_distributor_kyc_status']))) {
            setCurrModule(configs.modules.distKYC)
        } else {
            return history.goBack()
        }
    }, []);

    // customer kyc main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='kycContainer' className="kyc-container kyc-main">
                    {customerId ? <DistributorReviewRequestDetailPage /> : <DistributorReviewRequestsPage />}
                </div>
            </div>
        </>
    )
}